/**
 * Abstract base class for all Bkper resources.
 * Provides common functionality for config management and JSON serialization.
 *
 * @public
 */
export class Resource {
    /**
     * Constructs a new Resource
     * @param payload - The data payload for this resource
     */
    constructor(payload) {
        this.payload = payload || {};
    }
    /**
     * Gets an immutable copy of the JSON payload for this resource.
     * @returns An immutable copy of the json payload
     */
    json() {
        return Object.assign({}, this.payload);
    }
}
//# sourceMappingURL=Resource.js.map